package com.milta.core.localization.translations.en

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Scan a label",
    analysingTitle = "Reading the label…",
    analysingSubtitle = "We're looking for the recipient's name, address and phone number. It only takes a few seconds.",
    reviewTitle = "Confirm the delivery",
    deliveryDetectedLabel = "Delivery detected",
    allReadableLabel = "All readable",
    fieldToCompleteSingularSuffix = "field to complete",
    fieldToCompletePluralSuffix = "fields to complete",
    recipientNotDetectedValue = "Not detected",
    addressNotDetectedValue = "Not detected",
    phoneNotDetectedValue = "Not detected",
    fieldRequiredWarning = "Required field to add the delivery",
    recipientCorrectionPlaceholder = "Enter the recipient…",
    addressCorrectionPlaceholder = "Enter the address…",
    unreadableTitle = "Unreadable label.",
    unreadableMessage = "Retake a photo framed on the label, well lit and without glare.",
    maxAttemptsMessage = "Complete this delivery manually, or restart the scan with a new photo.",
)
